import { ReactElement } from 'react';
import { Avatar, Box } from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MultipleLinearProgresBar from '../MultipleLinearProgresBar';

import { TrackingInTransitDeliveriesItemProps } from './types';
import {
  TrackingInTransitDeliveriesListItemButton,
  TrackingInTransitDeliveriesListItemButtonInfo,
  TrackingInTransitDeliveriesListItemButtonInfoText,
  TrackingInTransitDeliveriesListItemButtonProgressContainer,
} from './styles';

const TrackingInTransitDeliveriesItem = <ED extends Record<string, unknown>>({
  label,
  totalCount,
  flexCount,
  standarCount,
  avatar,
  icon,
  onClick,
  progressMaxWidth = '100%',
  isSelected,
}: TrackingInTransitDeliveriesItemProps<ED>): ReactElement => {
  return (
    <TrackingInTransitDeliveriesListItemButton
      onClick={onClick}
      isSelected={isSelected}
    >
      <TrackingInTransitDeliveriesListItemButtonInfo>
        {avatar && <Avatar {...avatar} />}

        {icon && (
          <FontAwesomeIcon icon={icon.element} style={{ color: icon.color }} />
        )}

        <TrackingInTransitDeliveriesListItemButtonInfoText variant="inherit">
          {label}
        </TrackingInTransitDeliveriesListItemButtonInfoText>
      </TrackingInTransitDeliveriesListItemButtonInfo>

      <Box width="100%">
        <TrackingInTransitDeliveriesListItemButtonProgressContainer
          sx={{ maxWidth: progressMaxWidth }}
        >
          <MultipleLinearProgresBar
            items={[
              {
                label: 'Envíos estándar',
                value: standarCount,
                color: '#5618B6',
              },
              {
                label: 'Envíos Flex',
                value: flexCount,
                color: '#FFEB00',
              },
            ]}
            max={totalCount}
            size="medium"
            showLegend={false}
            showTotal
            borderRadiusType="right"
          />
        </TrackingInTransitDeliveriesListItemButtonProgressContainer>
      </Box>
    </TrackingInTransitDeliveriesListItemButton>
  );
};

export default TrackingInTransitDeliveriesItem;
